import { SWEDISH } from 'services/user/locale/utils';

/**
 * Format resource name based on locale
 * For English: returns the string before '#'
 * For Swedish: returns the string after '#'
 * If no '#' is found, returns the original name
 *
 * @param {string} name - The resource name (e.g., "Washing Machine#Tvättmaskin")
 * @param {string} locale - The current locale (e.g., 'en-US' or 'sv-SE')
 * @returns {string} The formatted name
 */
export function formatResourceName(name, locale) {
  if (!name) return '';

  if (!name.includes('#')) {
    return name;
  }

  const [swedishName, englishName] = name.split('#');

  return locale === SWEDISH ? swedishName.trim() : englishName.trim();
}

